import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { FileText, Loader2 } from 'lucide-react';
import { policiesApi } from '../services/api';

function PolicyFileRedirect() {
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      window.location.replace(policiesApi.viewUrl(id));
    }
  }, [id]);

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-gray-50 flex items-center justify-center px-4">
      <div className="bg-white border border-gray-200 rounded-2xl shadow-sm px-6 py-8 text-center max-w-sm w-full">
        <div className="w-14 h-14 rounded-2xl bg-[#00AAFF]/10 flex items-center justify-center mx-auto mb-4">
          <FileText className="w-7 h-7 text-[#00AAFF]" />
        </div>
        <h1 className="text-lg font-semibold text-gray-900 mb-2">Opening policy</h1>
        <p className="text-sm text-gray-500 mb-5">Redirecting you to the document in HRHub.</p>
        <Loader2 className="w-5 h-5 text-[#00AAFF] animate-spin mx-auto" />
      </div>
    </div>
  );
}

export default PolicyFileRedirect;
